import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import DemoBadge from '@/components/feature/DemoBadge';
import ProCollective from '@/pages/home/components/ProCollective';

export default function ProsPage() {
  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Header />
      <main>
        <section className="relative bg-foreground-950 pt-28 md:pt-40 pb-14 md:pb-20 px-4 md:px-8 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Golf%20professional%20demonstrating%20a%20swing%20position%20on%20a%20practice%20range%20at%20golden%20hour%2C%20dramatic%20side%20light%2C%20deep%20green%20background%20with%20dark%20edges%20for%20text%20contrast%2C%20cinematic%20sports%20photography%2C%20no%20logos&width=1920&height=1080&seq=gs-pros-hero&orientation=landscape"
            alt="Golf professional demonstrating a swing"
            title="The Pro Collective"
            className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/70 to-foreground-950/40"></div>
          <div className="relative">
            <div className="flex flex-wrap items-center gap-3">
              <p className="gs-rise font-label uppercase tracking-[0.25em] text-sm text-accent-400 font-bold">Pros</p>
              <DemoBadge label="Informational preview" tone="dark" />
            </div>
            <h1 className="gs-rise-2 font-heading font-extrabold uppercase text-background-50 text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight mt-2 max-w-5xl">
              Play smarter, locally.
            </h1>
            <p className="gs-rise-3 mt-5 text-background-200 text-base md:text-lg max-w-2xl">
              The Pro Collective connects Southern California golfers with local professionals through short, practical video series.
            </p>
          </div>
        </section>

        <ProCollective />

        <section className="bg-foreground-950 px-4 md:px-8 py-14 md:py-20 text-center">
          <h2 className="font-heading font-bold text-3xl md:text-5xl text-background-50 leading-tight">Are you a local pro?</h2>
          <p className="mt-4 text-background-200 max-w-xl mx-auto text-sm md:text-base">The full platform will let professionals apply to join the collective and publish lessons. For now this is an overview of the format.</p>
          <Link to="/partners" className="mt-7 inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-400 text-foreground-950 font-label font-bold uppercase tracking-wider px-6 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-mail-send-line"></i></span>Get in touch
          </Link>
        </section>
      </main>
      <Footer />
    </div>
  );
}